import type { ReactNode } from "react";

interface AuthCardProps {
  children?: ReactNode;
  description?: string;
  title: string;
}

export function AuthCard({
  children,
  description,
  title,
}: Readonly<AuthCardProps>) {
  return (
    <section className="rounded-2xl border border-border/60 bg-card p-6 text-card-foreground shadow-lg shadow-foreground/5 sm:p-7 xl:p-8 2xl:p-9 xl:[@media(max-height:800px)]:p-6">
      <header className="space-y-2 text-center">
        <h2 className="text-3xl font-bold tracking-tight text-card-foreground xl:text-[32px] xl:[@media(max-height:800px)]:text-[28px]">
          {title}
        </h2>
        {description ? (
          <p className="text-sm leading-6 text-muted-foreground">
            {description}
          </p>
        ) : null}
      </header>
      {children ? <div className="mt-8 xl:[@media(max-height:800px)]:mt-6">{children}</div> : null}
    </section>
  );
}
